import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/popout.svg'


const _withScopeId = n => (_pushScopeId("data-v-720ed790"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "socialsIntegration-base" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Community", -1))
const _hoisted_3 = { id: "widgets" }
const _hoisted_4 = { id: "discord-block" }
const _hoisted_5 = {
  key: 0,
  id: "discord-widget",
  src: "https://discord.com/widget?id=949802411801849866&theme=dark",
  frameborder: "0"
}
const _hoisted_6 = {
  key: 1,
  id: "no-cookies"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " This Discord widget uses cookies, accept cookies to enable it. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " We will only use essential cookies, and will never sell your data. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://discord.com/privacy",
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "View Discord Privacy Policy"
}, [
  /*#__PURE__*/_createTextVNode(" Discord Privacy Policy "),
  /*#__PURE__*/_createElementVNode("img", {
    alt: "pop-out icon",
    src: _imports_0
  })
], -1))
const _hoisted_12 = {
  id: "social-icons",
  "aria-label": "Bad Toad Games social links"
}
const _hoisted_13 = {
  "aria-label": "View Bad Toad Games YouTube Channel",
  href: "https://youtube.com/@badtoadgames7880",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_14 = {
  "aria-label": "Visit Bad Toad Games on Twitter",
  href: "https://twitter.com/bad_toad_games",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_15 = {
  "aria-label": "Visit Bad Toad Games on Tiktok",
  href: "https://www.tiktok.com/@bad_toad_games",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_16 = {
  "aria-label": "Visit Bad Toad Games on Facebook",
  href: "https://www.facebook.com/BadToadGames",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_17 = {
  "aria-label": "Bad Toad Games has a Paypal",
  href: "https://paypal.me/BadToadGamesLLC?country.x=US&locale.x=en_US",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_18 = { id: "fellow-indies" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Fellow Indies", -1))
const _hoisted_20 = { class: "indies-scroll" }
const _hoisted_21 = ["href", "aria-label"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = {
  key: 1,
  class: "indie-placeholder"
}
const _hoisted_24 = { class: "indie-name" }
const _hoisted_25 = {
  key: 0,
  class: "indies-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.cookiesAccepted)
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_5))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accepted && _ctx.accepted(...args)))
              }, "Accept Cookies"),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ])),
        _createElementVNode("nav", _hoisted_12, [
          _createElementVNode("a", _hoisted_13, [
            _createVNode(_component_fa, {
              class: "socials-icon",
              icon: ['fab', 'youtube']
            })
          ]),
          _createElementVNode("a", _hoisted_14, [
            _createVNode(_component_fa, {
              class: "socials-icon",
              icon: ['fab', 'twitter']
            })
          ]),
          _createElementVNode("a", _hoisted_15, [
            _createVNode(_component_fa, {
              class: "socials-icon",
              icon: ['fab', 'tiktok']
            })
          ]),
          _createElementVNode("a", _hoisted_16, [
            _createVNode(_component_fa, {
              class: "socials-icon",
              icon: ['fab', 'facebook']
            })
          ]),
          _createElementVNode("a", _hoisted_17, [
            _createVNode(_component_fa, {
              class: "socials-icon",
              icon: ['fab', 'paypal']
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fellowIndies, (indie) => {
            return (_openBlock(), _createElementBlock("a", {
              key: indie.name,
              class: "indie-card",
              href: indie.url,
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": `Visit ${indie.name}`
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["indie-logo-frame", { 'indie-logo-frame--light': indie.light }])
              }, [
                (indie.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: indie.image,
                      alt: `${indie.name} logo`,
                      class: "indie-image"
                    }, null, 8, _hoisted_22))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_fa, { icon: ['fas', 'image'] })
                    ]))
              ], 2),
              _createElementVNode("span", _hoisted_24, _toDisplayString(indie.name), 1)
            ], 8, _hoisted_21))
          }), 128)),
          (_ctx.fellowIndies.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, " More friends coming soon… "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}